const sites = ['nike', 'tipsport', 'fortuna', 'doxxbet']
const sports = ['football', 'tennis', 'hockey', 'basketball', 'handball', 'volleyball']
const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const defaultOptions = {
    "collapsed": false,
    "sites": ['nike', 'tipsport', 'fortuna', 'doxxbet','tipos','synottip'],
    "sports": ['football', 'tennis', 'hockey', 'basketball', 'handball', 'volleyball'],
    "min_roi": 0,
    "max": null,
    "min_active": 5,
    "games_key": null,
    "sortBy":'length'
}


export const Options = ({ options, setOptions, showOptions, setShowOptions }) => {

    const handleSiteClick = (name) => {
        if (options.sites.includes(name)) {
            setOptions({ ...options, sites: options.sites.filter(e => e !== name) })
        } else {
            setOptions({ ...options, sites: [...options.sites, name] })

        }
    }
    const handleSportClick = (name) => {
        if (options.sports.includes(name)) {
            setOptions({ ...options, sports: options.sports.filter(e => e !== name) })
        } else {
            setOptions({ ...options, sports: [...options.sports, name] })
        }
    }



    return (
        <>
            <div className={`${!showOptions && 'd-none'}`}>
                <div className='row justify-content-start  mt-2 mx-sm-2 px-2 px-sm-4'>
                    {sites.map(e => {
                        return (
                            <div key={e} className={`col-auto px-1  ${!options.sites.includes(e) && 'opacity-50'}`} style={{ 'cursor': 'pointer' }} onClick={() => handleSiteClick(e)}>
                                <img src={require(`../../static/images/sites/${e}.png`)} style={{ 'borderRadius': '2px', 'height': '20px' }} className="my-1" alt="Offer 1" ></img>
                            </div>
                        )
                    })}
                </div>
                <div className='row justify-content-start mx-sm-2 px-2 px-sm-4 d-flex align-items-center mt-2'>
                    <div className='col-auto p-0'>
                        minimalne roi
                    </div>
                    <div className='col-auto p-0'>
                        <input
                            value={options.min_roi}
                            onChange={e => { setOptions({ ...options, min_roi: e.target.value }) }}
                            name='min_roi'
                            type="number"
                            className="form-control text-center text-white placeholder-color-white p-0 text1 ms-2"
                            style={{ "height": '30px', 'width': '100px', "background": "#222222", 'fontSize': "18px", "boxShadow": `none`, 'borderRadius': '0.8em', 'border': 'none' }}
                        ></input>
                    </div>

                </div>
                <div className='row justify-content-start mx-sm-2 px-2 px-sm-4 d-flex align-items-cente mt-2'>
                    <div className='col-auto p-0'>
                        minimalne aktivna
                    </div>
                    <div className='col-auto p-0'>
                        <input
                            value={options.min_active}
                            onChange={e => { setOptions({ ...options, min_active: e.target.value }) }}
                            name='min_active'
                            type="number"
                            className="form-control text-center text-white placeholder-color-white p-0 text1 ms-2"
                            style={{ "height": '30px', 'width': '100px', "background": "#222222", 'fontSize': "18px", "boxShadow": `none`, 'borderRadius': '0.8em', 'border': 'none' }}
                        ></input>
                    </div>
                </div>
            </div>
        </>
    )
}

export const formatIsoString = (date) => {
    return {
        'day': days[(new Date(date)).getDay()],
        'date': new Date(date).getDate(),
        'month': months[(new Date(date)).getMonth()],
        'hour': (new Date(date)).getHours(),
        'minute': ((new Date(date)).getMinutes() < 10 ? '0' : '') + (new Date(date)).getMinutes(),
        'dateText': (
            (new Date(date).getDate() === new Date().getDate() &&
                new Date(date).getMonth() === new Date().getMonth())
                ? 'DNES'
                : (new Date(date).getDate() === new Date(new Date().setDate(new Date().getDate() + 1)).getDate() &&
                    new Date(date).getMonth() === new Date(new Date().setDate(new Date().getDate() + 1)).getMonth())
                    ? 'ZAJTRA'
                    : `${new Date(date).getDate()} ${months[(new Date(date)).getMonth()]}`
        )
    }
}